module.exports = __webpack_public_path__ + "img/merchantServicesBanner2.d03b5aa1.png";